import React from 'react';
import {numberFormat} from "../../helpers/toolbox";

const NpiDisplayNumber = ({value, fractionDigits=0}:{value: number, fractionDigits?:number}) => {
    return <span>{numberFormat(value??0, fractionDigits)}</span>;
};

export default NpiDisplayNumber;